/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/close.svg
 */
import type { IconProps } from '../types';
const Close = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
      d="M18.672 5.334 5.336 18.67m0-13.336L18.672 18.67"
    />
  </svg>
);
export default Close;
